var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTranslate = function SvgIconTranslate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#697477",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.5 3.877h5.667M5.333 3.833V2.5M8 9.5C5.29 8.799 3.897 7.076 3.5 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#697477",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.667 9.333c2.709-.68 4.102-2.35 4.5-5.333M9.563 11.417h3.541m1.063 1.416-2.21-5.849a.667.667 0 0 0-1.247 0l-2.21 5.85"
  })));
};
export { SvgIconTranslate as ReactComponent };
export default __webpack_public_path__ + "1a36a541515e8a1671c012991f512083.svg";